import { takeEvery, take, put, race, select } from 'redux-saga/effects';
import { confirmAction, cancelAction, hideConfirmation, showConfirmation } from '../slices/confirmation';
import { AppState } from '../root';

function* handlePromptConfirmationAction() {
  // The reducer already shows the modal, we just wait for user decision
  const { confirmed } = yield race({
    confirmed: take(confirmAction),
    cancelled: take(cancelAction),
  });

  if (confirmed) {
    // Get the stored action details from state
    const { actionType, actionPayload } = yield select((state: AppState) => state.confirmation);
    if (actionType && actionPayload) {
      // Re-dispatch the original action
      yield put({
        type: actionType,
        payload: actionPayload,
      });
    }
  }

  // Clear the confirmation state
  yield put(hideConfirmation());
}

export function* confirmationSaga() {
  yield takeEvery(showConfirmation, handlePromptConfirmationAction);
}
